<template>
    <div>
        <EsHeaderView @reload="goods_search"/>
        <div class="app-container">
            <!-- <div> -->
            <EsSortView @sort="sortEvent" :hide-new="false" v-if="isSort" />
            <!-- </div> -->
            <div v-loading="pageLoading" class="store-content-main">
                <div v-if="objsList.length" class="content">
                    <div v-for="item in objsList" :key="item.id" class="item">
                        <EsProductView :item="item" />
                    </div>
                </div>
                <div v-if="objsList.length" class="content-pagination">
                    <el-pagination background layout="total,prev, pager, next" class="es-pagination" :page-size="queryParams.pageSize"
                        :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
                </div>
                <el-empty v-if="!objsList.length && !pageLoading" :description="$t('message.home.noData')"></el-empty>
            </div>
        </div>
        <EsFooterView />
    </div>
</template>

<script>
import EsProductView from "@/components/product";
import EsSortView from "@/page/commodityPage/sort.vue";

//////////////////////////////////////////////////////////////////////////////////////////////////

import {
		search
	} from "@/api/goods/goods.js"

//////////////////////////////////////////////////////////////////////////////////////////////////

export default {
    name: "SearchGoods",
    components: {
        EsProductView,
        EsSortView,
    },
    data() {
        return {
            // keyword: "",
            pageLoading: true,
            pageNum: 1,
            pageSize: 12,
            total: 0,
            listData: [],
            isSort: true,
            isLoad: false,
            params: {},
            key:'',


//////////////////////////////////////////////////////////////////////////////////////////////////

                focus: true,
				hotKeyShow: true,
				historyKeyShow: true,
				searchValue: '',
				page: 0,
				goodsData: [],
				historyKeyList: [],
				hotKeyList: [],
				keyword: "",
				orderBy: '',
				orderType: '',
				activeIndex: 0,
				data: "",

				searchLoading: false,
				//"上拉加载"的变量，默认false，隐藏  
				objsList: [],
				loadType: "load",
				queryParams: {
					pageNumber: 1,
					pageSize: 10,
					// goodsCategoryId: '1',
					type: null,
					storeType: null,
					brandId: null,
					marketingId: null,
					goodsLabelId: null,
					startPrice: null,
					endPrice: null,
					isOutOfStock: null,
					keyword: null,
					storeId: null,
				},
				historyWindowShow: true,
				goodsLabels: [],
				historyKeywordList: null,

//////////////////////////////////////////////////////////////////////////////////////////////////


        };
    },
    activated() {
        //   this.isSort = true
        const { keyword } = this.$route.query;
        // if (!keyword) {
        //   this.$router.push("/");
        // } else {
        this.keyword = keyword
        this.$nextTick(() => {
        // this.pageInit();
        this.queryParams.keyword=keyword;
        this.goods_search();
        // this.searchGetOrSetHistoryKeyword(this.keyword);

        });
        // }
    },
    methods: {
        sortEvent(params) {
            this.queryParams.orderType =params.type;
            this.queryParams.pageNumber = 1;
            // this.getData(params);
            this.goods_search();
        },
        pageInit() {
            if (this.keyword) {
                if(!this.isLoad) {
                    this.getData();
                    this.isSort = false
                    setTimeout(() => {
                        this.isSort = true
                    }, 100);
                }
            } else {                
                this.$router.push("/");
            }
        },
        getData(params = {}) {
            this.pageLoading = true;
            if (this.keyword) {
                if (this.keyword.indexOf('&') !== -1 || this.keyword.indexOf('#') !== -1){
                const val  = JSON.parse(this.keyword)
                this.key =  String(encodeURIComponent(val)).trim()
                }else{
                const val  = JSON.parse(this.keyword)
                this.key = String(val).trim()
                }
                SearchResultListApi({
                    keyword: this.key,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                })
                    .then((res) => {
                        const { pageList, pageInfo } = res.data;
                        this.total = pageInfo.totalElements;
                        if (pageList.length) {
                            this.listData = pageList;
                        } else {
                            this.listData = [];
                        }
                        this.pageLoading = false;
                    })
                    .catch(() => {
                        this.pageLoading = false;
                    });
            }
        },
        currentChange(page) {
            this.queryParams.pageNumber = page;
            this.goods_search(this.params);
        },



//////////////////////////////////////////////////////////////////////////////////////////////////

/**
			 * 搜索列表 search
			 */
			goods_search() {
                this.pageLoading=true;
				search(this.queryParams).then(response => {
                    this.pageLoading = false;
					//下拉加载
					// if (this.loadType === "reach") {
					// 	const newObjsList = response.data.data.data.content;
					// 	newObjsList.forEach(item => this.objsList.push(item));
					// 	this.searchLoading = false;
					// 	//加载
					// } else if (this.loadType === "load") {
                this.objsList = response.data.data.data.content;
                this.goodsLabels = response.data.data.goodsLabels; //商品标签
                this.queryParams.pageNumber = response.data.data.data.pageable.pageNumber;
				this.total = response.data.data.data.total;
				this.totalPages = response.data.data.data.totalPages;
				// 		this.searchLoading = false;
				// 		//下拉刷新
				// 	} else if (this.loadType === "pullDown") {
				// 		uni.stopPullDownRefresh();
				// 	}
				});
			},
			onErrorImg(item) {
				this.$set(item, 'thumbnail', "/static/images/default_thumbnail.jpg");
			},
			keywordChange: function(e) {
				this.queryParams.keyword = e.detail.value;
				if (e.detail.value && e.detail.value != '') {
					this.historyWindowShow = false;
					this.objsList = [];
					this.loadType = 'load';
					this.queryParams.pageNumber = 1
					this.goods_search();
					// this.searchGetOrSetHistoryKeyword(e.detail.value);
				}
			},
			search_history_keyword_handler(keyword) {
				if (keyword && keyword != '') {
					this.historyWindowShow = false;
					this.queryParams.keyword = keyword;
					this.objsList = [];
					this.loadType = 'load';
					this.queryParams.pageNumber = 1
					this.goods_search();
					// this.searchGetOrSetHistoryKeyword(keyword);
				}
			},
			search_keyword_focus() {
				this.historyWindowShow = true;
			},
			searchGetOrSetHistoryKeyword: function(words) {
				var that = this;
				uni.getStorage({
					key: 'historyKeywordList',
					success: function(res) {
						if (words && res.data.indexOf(words) < 0 && words != null && words != 'null' && words !='') {
							res.data.unshift(words);
							if (res.data.length > 9) {
								res.data.pop();
							}
							uni.setStorage({
								key: "historyKeywordList",
								data: res.data
							});
						}
						that.historyKeywordList = res.data;
					},
					fail(e) {
						if(words){
							let historyKeywordList = [];
							historyKeywordList.push(words);
							uni.setStorage({
								key: "historyKeywordList",
								data: historyKeywordList
							});
							that.historyKeywordList = historyKeywordList;
						}
					}
				});
			},
			onOrder: function(event) {
				var that = this;
				this.queryParams.orderType = event.currentTarget.dataset.orderType;
				this.activeIndex = event.currentTarget.dataset.active;
				that.goods_search();
			},
			doKeySearch: function(e) {
				var that = this;
				var key = e.currentTarget.dataset.key;
				that.searchValue = key;
				that.hotKeyShow = false;
				that.historyKeyShow = false;
				this.goodsData.length = 0;
				this.loadGoodsSearch();
			},

//////////////////////////////////////////////////////////////////////////////////////////////////


    },
    // deactivated() {
    //       this.isSort = false;
    // },
    watch: {
        $route(to, from) {
            this.isLoad = from.path === '/productDetails'
            // this.pageInit();
        },
    },
};
</script>

<style scoped lang="scss">
.app-container {
    width: 1200px;
}

.tips-content {
    >span {
        color: var(--color-main);
    }
}

.store-content-main {
    min-height: 300px;
    margin-bottom: 40px;

    >.content {
        overflow: hidden;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
        grid-column-gap: 14px;
        grid-row-gap: 20px;
        align-content: center;
        padding: 40px 0;
        >.item {

            &:nth-child(6n) {
                margin-right: 0;
            }
        }
    }
}

.content-pagination {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
